/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformation,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformationFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformationFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformationToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformation';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfo
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfo {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfo
     */
    menuNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfo
     */
    menuNm?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfo
     */
    planNm?: string;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformation}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfo
     */
    categoryInfomation?: JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformation;
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfo {
    return JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'menuNo': !exists(json, 'menuNo') ? undefined : json['menuNo'],
        'menuNm': !exists(json, 'menuNm') ? undefined : json['menuNm'],
        'planNm': !exists(json, 'planNm') ? undefined : json['planNm'],
        'categoryInfomation': !exists(json, 'categoryInfomation') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformationFromJSON(json['categoryInfomation']),
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'menuNo': value.menuNo,
        'menuNm': value.menuNm,
        'planNm': value.planNm,
        'categoryInfomation': JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformationToJSON(value.categoryInfomation),
    };
}

